<template>
  <vs-row>
    <vs-col vs-w="12" v-if="error instanceof FetchError">
      <fetch-error @retry="error = null" :error="error"></fetch-error>
    </vs-col>
    <vs-col vs-w="12" v-else-if="hasNoData"> داده ای یافت نشد </vs-col>
    <template v-else>
      <template v-for="(item, index) in items">
        <slot v-bind:item="item" v-bind:index="index"></slot>
      </template>

      <vs-col vs-w="12">
        <infinite-loading @infinite="onRequestPage">
          <div slot="spinner">
            <loader></loader>
          </div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </vs-col>
    </template>
  </vs-row>
</template>

<script>
import FetchError from "../services/api/FetchError";

export default {
  props: {
    fetchPage: {
      required: true,
      type: Function,
    },
  },
  data() {
    return {
      currentPage: 1,
      hasNoData: false,
      hasMore: true,
      preventFromFetch: false,
      FetchError,
      items: [],
      error: null,
    };
  },
  methods: {
    refresh() {
      this.currentPage = 1;
      this.hasNoData = false;
      this.items = [];
      this.hasMore = true;
      this.preventFromFetch = false;
    },
    onRequestPage($state) {
      if (this.preventFromFetch === true || !this.hasMore) {
        $state.complete();
        return;
      }
      this.preventFromFetch = true;

      const fetchPageAction = this.fetchPage(this.currentPage);

      if (fetchPageAction instanceof Promise) {
        fetchPageAction
          .then(({ data: items, meta, additional }) => {
            let per_page = 0,
              last_page = 0;

            if (meta) {
              per_page = meta.per_page;
              last_page = meta.last_page;
            } else if (additional && additional.paginator) {
              per_page = additional.paginator.per_page;
              last_page = additional.paginator.last_page;
            }

            this.error = null;

            if (this.currentPage === 1 && items.length === 0)
              this.hasNoData = true;

            this.currentPage++;

            this.hasMore = this.currentPage <= (last_page || 1);

            this.items.push(...items);

            this.preventFromFetch = false;

            if (per_page < items.length) {
              $state.loaded();
            } else {
              $state.complete();
            }
          })
          .catch((err) => {
            this.error = err;
          });
      } else {
        $state.complete();
      }
    },
    deleteItem(item) {
      this.items = this.items.filter((el) => el.id !== item.id);
      if (this.items.length === 0) {
        this.hasNoData = true;
      }
    },
    createItem(item) {
      this.items.unshift(item);
      this.hasNoData = false;
    },
  },
  name: "UnlimitedList",
};
</script>

<style scoped></style>
